import React, { useEffect, useState, useCallback } from "react"
import PropTypes from "prop-types"
import { useHistory } from "react-router-dom"
import { useLocation, useParams } from "react-router"
import "bootstrap/dist/css/bootstrap.min.css"
import PLUS_ICON from "../../../assets/images/plus-icon.png"
//import components
import Breadcrumbs from "../../../components/Common/Breadcrumb"
import TRASH_ICON from "../../../assets/images/trash-can-icon-png-19.jpg"
//redux
import { useSelector, useDispatch } from "react-redux"

import {
  Col,
  Row,
  Card,
  CardBody,
  Label,
  Modal,
  ModalHeader,
  ModalBody,
  UncontrolledTooltip,
  Spinner,
} from "reactstrap"
import DeleteModal from "../../../components/Common/DeleteModal"
import {
  deleteVendor_media,
  getVendor_media,
} from "../../../store/vendor_media/actions"
import {
  deleteFile,
  getFiles,
  getFolders,
  uploadFilesToFolder,
} from "../../../helpers/backend_helper"
import imageBaseUrl from "../../../helpers/imageBaseUrl"
import Dropzone from "react-dropzone"
import moment from "moment"

function VendorFileManagerFiles() {
  const history = useHistory()
  const params = useParams()
  const location = useLocation()
  const [vendor, setVendor] = useState([])
  const [offset, setOffset] = useState(0)
  const [page_size, setPageSize] = useState(10)
  const [modal, setModal] = useState(false)
  const [selectedFiles, setselectedFiles] = useState([])
  const [loading, setloading] = useState(false)
  const [files, setFiles] = useState([])
  const [percentageLoader,setPercentageLoader] = useState(0)
  const dispatch = useDispatch()
  function handleAcceptedFiles(files) {
    files.map(file =>
      Object.assign(file, {
        preview: URL.createObjectURL(file),
        formattedSize: formatBytes(file.size),
      })
    )

    setselectedFiles(files)
  }

  /**
   * Formats the size
   */
  function formatBytes(bytes, decimals = 2) {
    if (bytes === 0) return "0 Bytes"
    const k = 1024
    const dm = decimals < 0 ? 0 : decimals
    const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"]

    const i = Math.floor(Math.log(bytes) / Math.log(k))
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i]
  }
  const _getFolders = async () => {
    try {
      const result = await getFiles({ id: params.id, offset, page_size })
      if (result.success) {
        setFiles(result.data)
      }
    } catch (e) {}
  }
  useEffect(() => {
    _getFolders()
  }, [offset, page_size])

  const handleUserClick = useCallback(
    arg => {
      const vendor = arg
      history.push("/vendors/add", vendor)
    },
    [history]
  )

  //delete vendor
  const [deleteModal, setDeleteModal] = useState(false)
  const toggle = useCallback(() => {
    if (modal) {
      setModal(false)
    } else {
      setModal(true)
    }
  }, [modal])
  const onClickDelete = vendor => {
    setVendor(vendor)
    setDeleteModal(true)
  }

  const handleUploads = async () => {
    try {
      setloading(true)
      selectedFiles.map(async (s,i) => {
        await uploadFilesToFolder({
          folder_id: params.id,
          files: s,
          modified_at:moment(Date.now()).format('DD-MMM-YYYY, hh:mm A')
        })
        if(i === selectedFiles.length - 1 ){
           setloading(false)
           setModal(false)
           _getFolders()
        }
      })
      // setloading(false)
    } catch (e) {
      setloading(false)
      setModal(false)
      console.log(e)
    }
  }


  const handleDeleteUser = async () => {
    if (vendor.id) {
      await deleteFile({ id: vendor.id })
      _getFolders()
      setDeleteModal(false)
    }
  }
  useEffect(() => {
    if (!loading) {
      setDeleteModal(false)
    }
  }, [loading])

  return (
    <React.Fragment>
      <DeleteModal
        show={deleteModal}
        onDeleteClick={handleDeleteUser}
        onCloseClick={() => setDeleteModal(false)}
        loading={loading}
      />
      <div className="page-content">
        <div className="container-fluid">
          <Breadcrumbs
            title="MENU"
            breadcrumbItem={location?.state?.vendor_name}
          />
          <Row>
            <Col xs="12">
              {/* <Card> */}
              {/* <CardBody> */}
              <div style={{ display: "flex", flexWrap: "wrap", columnGap: 10 }}>
                <div
                  onClick={() => setModal(true)}
                  className="col-1"
                  style={{
                    backgroundColor: "white",
                    boxShadow: "0 0 10px rgba(0, 0, 0, 0.2)",
                    borderRadius: 5,
                    display: "flex",
                    justifyContent: "center",
                  }}
                >
                  <img
                    style={{ alignSelf: "center" }}
                    src={PLUS_ICON}
                    width={"40%"}
                  />
                </div>
                {files.length > 0
                  ? files.map(folder => (
                      <div
                        key={folder.id}
                        className="col-3"
                        style={{
                          textAlign: "center",
                          backgroundColor: "white",
                          boxShadow: "0 0 10px rgba(0, 0, 0, 0.2)",
                          borderRadius: 5,
                        }}
                      >
                        <div onClick={() => onClickDelete(folder)}>
                          <img
                            src={TRASH_ICON}
                            width={"10%"}
                            style={{ float: "right" }}
                          />
                        </div>
                        <img
                          onClick={() => history.push("files/" + folder.id)}
                          src={imageBaseUrl + folder.file_name}
                          width={"40%"}
                        />
                      </div>
                    ))
                  : null}
              </div>
              {/* </CardBody>
              </Card> */}
            </Col>
          </Row>
          <Modal isOpen={modal} toggle={toggle}>
            <ModalHeader toggle={toggle} tag="h4">
              {"Uploads Images"}
            </ModalHeader>
            <ModalBody>
              <Dropzone
                onDrop={acceptedFiles => {
                  handleAcceptedFiles(acceptedFiles)
                }}
              >
                {({ getRootProps, getInputProps }) => (
                  <div className="dropzone">
                    <div className="dz-message needsclick" {...getRootProps()}>
                      <input {...getInputProps()} />
                      <div className="mb-3">
                        <i className="display-4 text-muted uil uil-cloud-upload" />
                      </div>
                      <h4>Drop files here or click to upload.</h4>
                    </div>
                  </div>
                )}
              </Dropzone>
              <div className="dropzone-previews mt-3" id="file-previews">
                {selectedFiles.map((f, i) => {
                  return (
                    <Card
                      className="mt-1 mb-0 shadow-none border dz-processing dz-image-preview dz-success dz-complete"
                      key={i + "-file"}
                    >
                      <div
                        className="p-2"
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                        }}
                      >
                        <Row className="align-items-center">
                          <Col className="col-auto">
                            <img
                              data-dz-thumbnail=""
                              height="80"
                              className="avatar-sm rounded bg-light"
                              alt={f.name}
                              src={f.preview}
                            />
                          </Col>
                          <Col>
                            <Label
                              to="#"
                              className="text-muted font-weight-bold"
                            >
                              {f.name}
                            </Label>
                            <p className="mb-0">
                              <strong>{f.formattedSize}</strong>
                            </p>
                          </Col>
                        </Row>
                        <div
                          className="align-self-center"
                          onClick={() => {
                            setselectedFiles([])
                          }}
                        >
                          <i
                            className="uil uil-trash-alt font-size-24 text-danger"
                            id="deletetooltip"
                          />
                          <UncontrolledTooltip
                            placement="top"
                            target="deletetooltip"
                          >
                            Delete
                          </UncontrolledTooltip>
                        </div>
                      </div>
                    </Card>
                  )
                })}
              </div>
              <Row>
                <Col>
                  <div className="text-end mt-3">
                    {loading ? (
                      <div>
                         <Spinner
                        type="grow"
                        className="m-1 center"
                        color="primary"
                      >
                     
                      </Spinner>
                      <Label>{percentageLoader}</Label>
                        </div>
                     
                    ) : (
                      <button
                        type="button"
                        className="btn btn-success save-user"
                        onClick={() => handleUploads()}
                      >
                        Save
                      </button>
                    )}
                  </div>
                </Col>
              </Row>
            </ModalBody>
          </Modal>
        </div>
      </div>
    </React.Fragment>
  )
}
VendorFileManagerFiles.propTypes = {
  preGlobalFilteredRows: PropTypes.any,
}

export default VendorFileManagerFiles
